<template>
  <div class="wa-loading" v-loading="true" element-loading-background="rgba(255, 255, 255, 1)"></div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getUserInfoBySession } from '@/api/whatsapp'
import { Storage } from '@/utils/storage'

const router = useRouter()
const route = useRoute()

const WA_LOGIN_STORAGE_KEY = 'wa_login_user'
const WA_MANUAL_LOGOUT_KEY = 'wa_manual_logout'

const getCurrentSystemUserId = () => {
  try {
    const userInfo = Storage.get('userInfo')
    const userId = userInfo?.id || userInfo?.userId
    return userId ? String(userId) : ''
  } catch (e) {
    console.error('[WA Loading] 获取系统用户ID失败:', e)
    return ''
  }
}

const saveWaLoginUser = (user) => {
  try {
    const systemUserId = getCurrentSystemUserId()
    // 同时保存到通用 key（兼容性）和账号特定 key
    Storage.set(WA_LOGIN_STORAGE_KEY, user || {})
    if (systemUserId) {
      Storage.set(`${WA_LOGIN_STORAGE_KEY}_${systemUserId}`, user || {})
      console.log(`[WA Loading] 保存登录信息: systemUserId=${systemUserId}, waId=${user?.id}`)
    }
  } catch (e) {
    console.error('[WA Loading] 保存登录信息失败:', e)
  }
}

const clearWaLoginUser = () => {
  try {
    const systemUserId = getCurrentSystemUserId()
    Storage.remove(WA_LOGIN_STORAGE_KEY)
    if (systemUserId) {
      Storage.remove(`${WA_LOGIN_STORAGE_KEY}_${systemUserId}`)
      console.log(`[WA Loading] 清除登录信息: systemUserId=${systemUserId}`)
    }
  } catch (e) {
    console.error('[WA Loading] 清除登录信息失败:', e)
  }
}

const parseUserInfoResult = (res) => {
  const payload = res?.result || res?.data?.result || res?.data || res
  return {
    id: payload?.id,
    pushName: payload?.pushName,
    name: payload?.name || payload?.pushName,
    picture: payload?.picture
  }
}

const gotoLogin = () => {
  router.replace({
    path: '/whatsapp/walogin',
    query: {
      ...(route.query || {}),
      skipLoading: '1'
    }
  })
}

onMounted(async () => {
  try {
    const manualLogoutAt = Storage.get(WA_MANUAL_LOGOUT_KEY)
    if (manualLogoutAt) {
      clearWaLoginUser()
      gotoLogin()
      return
    }
  } catch (e) {
  }

  try {
    const res = await getUserInfoBySession({}, { errorPop: false })
    const info = parseUserInfoResult(res)
    if (info?.id && (info?.name || info?.pushName)) {
      saveWaLoginUser({
        id: info?.id,
        pushName: info?.pushName,
        name: info?.name || info?.pushName,
        picture: info?.picture
      })
      router.replace('/whatsapp/wahome')
      return
    }
  } catch (e) {
  }

  clearWaLoginUser()
  gotoLogin()
})
</script>

<style scoped>
.wa-loading {
  width: 100%;
  height: calc(100vh - 48px);
  background: #fff;
}
</style>
